'use strict';

import {changeLangToCurrent} from "../language/langSwitcher";

export class Disclaimer {
    #element = document.createElement('span');
    #text = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.';
    constructor(parent) {
        if (!parent) return;

        this.#element.classList.add('disclaimer', 'language-string');
        this.#setText();

        parent.appendChild(this.#element);
    }

    set text(value) {
        if (!this.#element) return;

        this.#text = value;
        this.#setText();
    }

    #setText() {
        this.#element.setAttribute('data-dictionary', this.#text);
        this.#element.innerHTML = changeLangToCurrent(this.#text);
    }

    setStyle(styleName, value) {
        if (!this.#element) return;

        this.#element.style[`${styleName}`] = value;
    }

    addClass(className) {
        if (!this.#element) return;

        this.#element.classList.add(className);
    }

    show() {
        if (!this.#element) return;

        this.#element.classList.remove('hidden');
    }

    hide() {
        if (!this.#element) return;

        this.#element.classList.add('hidden');
    }
}